import React, { useMemo } from "react";
import DatePickerCustom from "components/atoms/DatePickerCustom";
import { TemplateExcelDataInfo } from "services/models";
import LabelRequired from "components/atoms/LabelRequired";
import formatDateToString from "@utils/DateFormat";
import { labeltextBreak } from "@utils/index";
import { CUSTOM_FORMAT } from "@shared-constants";

interface IDateInputField {
  setting: TemplateExcelDataInfo;
  value?: string;
  onChange?: (text: string) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
}

const DateInputField = ({
  setting,
  value,
  onChange = () => {},
  onBlur = () => {},
  error,
  helperText,
}: IDateInputField) => {
  const use_ym_proprs = useMemo(() => {
    // カスタマイズ形式にDがない場合、年月のみの入力項目にする
    return (
      setting.dateFormat == CUSTOM_FORMAT &&
      !setting.customizeFormat?.includes("D")
    );
  }, [setting]);

  return (
    <DatePickerCustom
      label={
        setting.required ? (
          <LabelRequired title={labeltextBreak(setting.name)} />
        ) : (
          labeltextBreak(setting.name)
        )
      }
      onChange={(v) => {
        let date_string = "";
        if (v) {
          if (!use_ym_proprs) {
            date_string = formatDateToString(v, "YMD_sl");
          } else {
            date_string = formatDateToString(v, "YM_sl") + "/01";
          }
        }
        onChange(date_string);
      }}
      value={value && value.length > 0 ? value : null}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      {...(use_ym_proprs && {
        openTo: "year",
        views: ["year", "month"],
        inputFormat: "yyyy/MM",
        mask: "____/__",
      })}
    />
  );
};

export default DateInputField;
